import Honeybadger from 'honeybadger-js';

Honeybadger.configure({
  apiKey: 'd112af54',
  environment: process.env.NODE_ENV,
  disabled: process.env.NODE_ENV === 'development',
  onerror: process.env.NODE_ENV !== 'development',
  async: true,
  debug: process.env.NODE_ENV === 'development',
});

Honeybadger.beforeNotify(notice => {
  notice.name = global.appConfig.name;
});

export default Honeybadger;
